<h2 mat-dialog-title>{{title}}</h2>
<mat-dialog-content>
  <div class="member-page d-flex align-items-center gap-3 mb-4">
    <form [formGroup]="form" class="filters d-flex align-items-center gap-3 flex-wrap">
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Member name</mat-label>
        <mat-icon matPrefix class="me-1">person</mat-icon>
        <input matInput formControlName="name" />
      </mat-form-field>
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Member mail</mat-label>
        <mat-icon matPrefix class="me-1">mail</mat-icon>
        <input matInput formControlName="mail" />
      </mat-form-field>
      @if (data === 'CREATE') {
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Password</mat-label>
        <mat-icon matPrefix class="me-1">key</mat-icon>
        <input matInput type="password" formControlName="pass" />
      </mat-form-field>
      }
      <mat-slide-toggle formControlName="status">
        Status
      </mat-slide-toggle>
      <mat-form-field appearance="fill" class="filters-form-field">
        <mat-label>Roles</mat-label>
        <mat-icon matPrefix class="me-1">badge</mat-icon>
        <mat-select formControlName="roles" multiple>
          <mat-option value="chronos_tracker">Chronos Tracker</mat-option>
          <mat-option value="chronos_manager">Chronos Manager</mat-option>
          <!-- Add other roles as needed -->
        </mat-select>
      </mat-form-field>
    </form>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="memberSubmit()">{{submitButton}}</button>
</mat-dialog-actions>
